/**
 * API path for a legacy per-drawing image on a project-file batch.
 */
export const getProjectFileDrawingImagePath = (
  batchId: string,
  fileId: string,
  drawingId: string,
): string =>
  `admin/project-file-batches/${batchId}/files/${fileId}/drawings/${drawingId}`;

/** API path for one page raster. Drawings on that page are coordinates into it. */
export const getProjectFilePageRasterPath = (
  batchId: string,
  fileId: string,
  pageIndex: number,
): string =>
  `admin/project-file-batches/${batchId}/files/${fileId}/pages/${pageIndex}`;
